module.exports = __webpack_public_path__ + "img/privateC-icon5.588f3850.png";